import React, { useEffect } from 'react';
import Resizer from "react-image-file-resizer";
import { MediaUpload } from '../../../Constant/api';
import { useSelector } from 'react-redux';

export default function PDFUpload(props) {
  const {
    ImageUrl,
    setImageUrl,
  } = props;
  const fileRefSingle = React.createRef();
  const [Loading, setLoading] = React.useState(false)
  const Login = useSelector((state) => state.LoginState);

  const MediaUploadSingleCall = (file, i) => {
    if (!file) return;
    var fileInput = "";
    if (file) {
      fileInput = file.type;
    }
    // try {
    // Resizer.imageFileResizer(
    //   file,
    //   1000,
    //   1000,
    //   "JPEG",
    //   40,
    //   0,
    //   (uri) => {
    // this.setState({ newImage: uri });
    // console.log("2", uri)
    // const name = file.name.toLowerCase().replace(/[^\x00-\x7F]/g, "").trim();      ;
    // const name = file.name.toLowerCase().replace(/[^\x00-\x7F]/g, "") // remove unicode
    //   .replace(/\s+/g, " ")         // normalize spaces
    //   .trim();
    const date= new Date()
    const name = `${Login.userName}-${date.getTime()}.pdf`
    console.log(`A${name}`)
    // .trim()
    // .replace(/[^\w\s-]/g, '')
    // .replace(/[\s_-]+/g, '-')
    // .replace(/^-+|-+$/g, '')
    // const file2 = new File([file],name,type);
    const file2 = new File([file], `${name}`);

    MediaUpload(file2)
      .then(res => res.json())
      .then(data => {
        setImageUrl(data.source_url)
        setTimeout(() => {
          setLoading(false)
        }, 1000);
      })
      .catch(err => { console.log("error", err.message); })
      .finally(() => { })
    // },
    //   "file",
    //   200,
    //   200
    // );
    // } catch (err) {
    //   console.log(err);
    // }
  }

  return (
    <div>
      {Loading &&
        <div className="spinner-border"></div>
      }
      <div className="">
        <div className="row">
          {ImageUrl !== "" ?
            <div className="my-2">
              <div className=" ">
                <button type="button" onClick={() => { fileRefSingle.current.click() }}
                  className="bg-transparent border-0 p-1 "
                >
                  {/* <img src={`${ImageUrl}`} className={" border border-dark"}
                    height="100px"
                  /> */}
                  <iframe

                    src={`${ImageUrl}`}

                    style={{ width: "400px", height: "400px" }}
                  />
                </button>
              </div>
              <button onClick={() => {
                setImageUrl("")
              }}
                className="bg-transparent border-0 p-1 "
              ><u>Clear</u></button>
            </div>
            :
            <div className="col-3">
              <button type="button"
                onClick={() => {
                  fileRefSingle.current.click()
                }}
                className="bg-transparent border-0 p-1 "
              >
                <div className="border height-width-150 border-dark m-1 p-4 font-size-12">
                  <i className="fa fa-camera font-size-18"></i>
                  <div>Add PDF</div>
                </div>
              </button>
            </div>
          }
        </div>
      </div>
      <div style={{ display: 'none' }}>
        <input type="file" accept="application/*" name="image" id="file" ref={fileRefSingle}
          onChange={(event) => {
            if (event.target.files.length !== 0) {
              setLoading(true)
              MediaUploadSingleCall(event.target.files[0])
            }
          }}
        />
      </div>


    </div>
  )
}